<template>
    <ContentOrLoading>
        <ValidationObserver ref="observer" v-if="!loading">
            <section class="pt-0 mb-3 mb-lg-4" id="paso-5">
                <div>
                    <div class="row">
                        <div class="col-12 mb-4 h4 text-uppercase pt-4">
                            {{ $t('bases.indumentarias_disponibles') }}
                        </div>
                        <template v-for="(indumentaria, index) in indumentarias">
                            <div class="col-12 col-md-6 col-xl-4 text-center mb-3" :key="indumentaria.id">
                                <div class="card mx-auto">
                                    <div class="mx-auto mt-2">
                                        <img class="card-img-top" :src="indumentaria.imagen" alt="" style="height: 180px; max-height: 190px; max-width: 240px;"/>
                                    </div>
                                    <div style="color: #013765">
                                        <h4>{{ indumentaria.nombre }}</h4>
                                        <div v-if="indumentaria.incluida">
                                            <h4 class="m-0"><del>{{ indumentaria.precio | formatear_precio }}</del> <h3 class="d-inline ml-1">(0 €)</h3></h4>
                                            <small>{{ $t('bases.max_incluidas') }} {{ indumentaria.cantidad_incluida }}</small>
                                        </div>
                                        <h3 v-else>{{ indumentaria.precio | formatear_precio }}</h3>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <ValidationProvider name="talla" :id="'talla-' + index">
                                            <multiselect
                                                v-model="indumentaria.tallaSelect"
                                                :disabled="loading"
                                                :id="'talla-' + index"
                                                :placeholder="$t('bases.talla_indumentaria')"
                                                class="mr-1"
                                                style="width: 5.5rem;"
                                                label="nombre"
                                                track-by="id"
                                                :options="indumentaria.tallasSelect"
                                                :show-labels="false"
                                                :data-cy="'talla-' + index"
                                            >
                                                <template slot="noOptions">{{ $t('bases.no_tallas') }}</template>
                                            </multiselect>
                                        </ValidationProvider>
                                        <ValidationProvider v-if="indumentaria.tallaSelect" name="stock" :id="'stock-' + index">
                                            <multiselect
                                                v-model="indumentaria.stockSelect"
                                                :disabled="!indumentaria.tallaSelect || loading"
                                                :id="'stock-' + index"
                                                placeholder="Ud"
                                                style="width: 4.7rem;"
                                                :options="indumentaria.tallaSelect.stockArray"
                                                :show-labels="false"
                                                :data-cy="'stock-' + index"
                                            >
                                                <template slot="noOptions">{{ $t('bases.no_unidades') }}</template>
                                            </multiselect>
                                        </ValidationProvider>
                                    </div>
                                    <button :disabled="!indumentaria.tallaSelect || !indumentaria.stockSelect" type="button" data-cy="add-indumentaria" :id="'add-indumentaria-' + index" class="btn p-1 m-1" style="font-size: 12px;" @click="addIndumentaria(indumentaria)">{{ $t('bases.anadir_indumentaria') }}</button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="text-center" v-if="indumentariasElegidas?.length">
                    <hr width="69%"/>
                    <h4>{{ $t('bases.indumentarias_elegidas') }}</h4>
                    <small style="font-size: 11px;"><b>{{ $t('bases.indumentaria_incluida') }}</b></small><br/>
                    <div class="has-options mt-4">
                        <b-table style="width: 69%; margin: auto;" hover :items="indumentariasElegidas" :fields="fields" id="indumentarias-table">
                            <template #cell(precio)="{ item }">
                                <p v-if="item.incluida"><del>{{ item.precio | formatear_precio }}</del> ({{ '0' | formatear_precio }})</p>
                                <p v-else>{{ item.precio | formatear_precio }}</p>
                            </template>
                            <template #cell(talla)="{ item }">
                                <p>{{ item.talla.nombre }}</p>
                            </template>
                            <template #cell(cantidad)="{ item }">
                                <p>{{ item.unidades }}</p>
                            </template>
                            <template #cell(imagen)="{ item }">
                                <img :src="item.imagen" style="width: 75px;"/>
                            </template>
                            <template #cell(eliminar)="{ item }">
                                <button class="border-0 bg-transparent p-2" type="button" @click="eliminarIndumentaria(item)" :disabled="loading"><h6><i class="text-danger fas fa-times-circle"></i></h6></button>
                            </template>
                        </b-table>
                    </div>
                    <hr/>
                    <b-row class="customWidth" style=" margin: auto;" v-if="indumentariasElegidas.length > 0">
                        <b-col md="12" lg="6">
                            <div class="form-group">
                                <label for="camiseta_nombre">{{ $t('bases.nombre_indumentarias') }}</label>
                                <input
                                    id="camiseta_nombre"
                                    type="text"
                                    class="form-control"
                                    v-model="localData.camiseta_nombre"
                                    :placeholder="$t('bases.nombre_indumentarias')"
                                    :disabled="loading"
                                />
                            </div>
                        </b-col>
                        <b-col md="12" lg="6">
                            <div class="form-group">
                                <label for="camiseta_numero">{{ $t('bases.numero_indumentarias') }}</label>
                                <input
                                    id="camiseta_numero"
                                    type="text"
                                    class="form-control"
                                    v-model="localData.camiseta_numero"
                                    :placeholder="$t('bases.numero_indumentarias')"
                                    :disabled="loading"
                                />
                            </div>
                        </b-col>
                    </b-row>
                    <hr width="69%"/>
                </div>
                <div v-if="error_indumentaria_reservada" class="alert alert-danger" role="alert">
                    {{ error_indumentaria_reservada }}
                </div>
                <div class="col-12 text-right mt-4">
                    <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-4" :disabled="loading">
                        <span>{{ $t('formularios.atras') }}</span>
                    </button>
                    <button @click="terminar" type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" data-cy="terminar-paso-indumentarias" id="terminar-paso-5" :disabled="loading">
                        <span>{{ $t('formularios.continuar') }}</span>
                    </button>
                </div>
            </section>
        </ValidationObserver>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {
        props: ["base", "esMovil"],
        data() {
            return {
                select: false,
                indumentarias: null,
                indumentariasElegidas: this.base?.categoria_base?.indumentariasElegidas ?? [],
                error_indumentaria_reservada: null,
                fields: [
                    { key: "nombre", label: this.$t('bases.nombre_indumentaria'), class: 'text-center' },
                    { key: "precio", label: this.$t('bases.precio_indumentaria'), class: 'text-center' },
                    { key: "talla", label: this.$t('bases.talla_indumentaria'), class: 'text-center' },
                    { key: "cantidad", label: this.$t('bases.cantidad_indumentaria'), class: 'text-center' },
                    { key: 'imagen', label: this.$t('bases.imagen_indumentaria'), class: 'text-center' },
                    { key: 'eliminar', label: "", class: 'text-center' }
                ],
                loading: false,
                localData: { ...this.base }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_id() {
                return this.$route.params.lista_id;
            },
            indumentariasIncluidasPendientes() {
                if (!this.indumentarias?.length) return [];
                return this.indumentarias?.filter(ind =>
                    ind.incluida &&
                    ind.tallasSelect?.some(talla => talla.stockArray?.length > 0) &&
                    !this.indumentariasElegidas.some(elegida => elegida.id === ind.id && elegida.incluida)
                );
            }
        },
        methods: {
            getIndumentarias() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    categoria_id: this.localData.categoria_base.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.categorias.bases.indumentarias'), params).then(res => {
                    this.indumentarias = res.data.indumentarias;
                    this.loading = false;
                })
            },
            reservarIndumentaria() {
                this.loading = true;

                let params = {
                    indumentarias: this.indumentariasElegidas,
                    session_id: this.base.categoria_base.session_id,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.bloquear-indumentarias'), params).then(res => {
                    this.localData.categoria_base.session_id = res.data.session_id;
                    this.$emit("terminado", this.indumentariasElegidas, this.localData);
                }).catch(error => {
                    this.error_indumentaria_reservada = error.response.data.message;
                    this.getIndumentarias();
                    this.indumentariasElegidas = [];
                }).finally(() => {
                    this.loading = false;
                });
            },
            addIndumentaria(indumentaria) {
                if (this.indumentariasElegidas && this.indumentariasElegidas.length > 0) {
                    while(this.indumentariasElegidas.filter(ind => ind.id === indumentaria.id && ind.talla.id === indumentaria.tallaSelect.id).length > 0) {
                        this.indumentariasElegidas.splice(this.indumentariasElegidas.findIndex(el => el.id === indumentaria.id && el.talla.id === indumentaria.tallaSelect.id), 1);
                    }
                }

                if(indumentaria.incluida && this.indumentariasElegidas.filter(ind => ind.id === indumentaria.id && ind.incluida === true).length == 0) {
                    const indumentaria_incluida = {
                        id: indumentaria.id,
                        talla: {
                            id: indumentaria.tallaSelect.id,
                            nombre: indumentaria.tallaSelect.nombre,
                            stockDisponible: indumentaria.tallaSelect.stockDisponible,
                            stock_total: indumentaria.tallaSelect.stock_total
                        },
                        unidades: indumentaria.stockSelect < indumentaria.cantidad_incluida ? indumentaria.stockSelect : indumentaria.cantidad_incluida,
                        precio: indumentaria.precio,
                        precio_total: 0,
                        incluida: true,
                        nombre: indumentaria.nombre,
                        imagen: indumentaria.imagen
                    }

                    this.indumentariasElegidas.push(indumentaria_incluida);

                    this.error_indumentaria_reservada = null;

                    if(indumentaria.stockSelect - indumentaria.cantidad_incluida > 0) {
                        const resto_indumentarias = {
                            id: indumentaria.id,
                            talla: {
                                id: indumentaria.tallaSelect.id,
                                nombre: indumentaria.tallaSelect.nombre,
                                stockDisponible: indumentaria.tallaSelect.stockDisponible,
                                stock_total: indumentaria.tallaSelect.stock_total
                            },
                            unidades: indumentaria.stockSelect - indumentaria.cantidad_incluida,
                            precio: indumentaria.precio,
                            precio_total: indumentaria.precio * indumentaria.stockSelect - (indumentaria.precio * indumentaria.cantidad_incluida),
                            incluida: false,
                            nombre: indumentaria.nombre,
                            imagen: indumentaria.imagen
                        }

                        this.indumentariasElegidas.push(resto_indumentarias);
                    }
                } else {
                    const resto_indumentarias = {
                        id: indumentaria.id,
                        talla: {
                            id: indumentaria.tallaSelect.id,
                            nombre: indumentaria.tallaSelect.nombre,
                            stockDisponible: indumentaria.tallaSelect.stockDisponible,
                            stock_total: indumentaria.tallaSelect.stock_total
                        },
                        unidades: indumentaria.stockSelect,
                        precio: indumentaria.precio,
                        precio_total: indumentaria.precio * indumentaria.stockSelect,
                        incluida: false,
                        nombre: indumentaria.nombre,
                        imagen: indumentaria.imagen
                    }

                    this.indumentariasElegidas.push(resto_indumentarias);
                }
                indumentaria.tallaSelect = null;
                indumentaria.stockSelect = null;
            },
            eliminarIndumentaria(indumentaria) {
                this.indumentariasElegidas.splice(this.indumentariasElegidas.findIndex(el => el.unidades === indumentaria.unidades && el.talla.id === indumentaria.talla.id), 1);
            },
            terminar() {
                if (!this.indumentariasElegidas?.length && !this.indumentariasIncluidasPendientes.length) {
                    this.$emit('terminado', null, this.localData);
                    return;
                }

                if (this.indumentariasIncluidasPendientes.length) {
                    this.error_indumentaria_reservada = this.$t('bases.debes_seleccionar_incluidas');
                    return;
                }

                this.error_indumentaria_reservada = null;
                this.reservarIndumentaria();
            },
            volver() {
                this.$emit('volver');
            }
        },
        created() {
            this.getIndumentarias();
        },
        components: {
            ContentOrLoading
        },
    };
</script>

<style scoped>
    .overlay {
        position: relative;
    }

    .overlay_0 {
        position: absolute;
        top: 80px;
        left: 20px;
        color: red;
        transform: rotate(330deg);
    }

    .customWidth{
        width: 70%;
    }

    @media (max-width: 768px) {
    .customWidth{
        width: 100%;
    }

    @media (max-width: 768px) {

        .custom-btn {
            width: 100%;
            max-width: 400px;
            margin: 0.3rem 0;
        }
    }
}
</style>
